import { Label } from '@wolfejs/ui/Form';
import { RadioGroup, RadioGroupItem } from '@wolfejs/ui/RadioGroup';
import { cn } from '../utils/classnames';

export type RadioItem = {
  label: React.ReactNode;
  value: string;
};

export type RadioGroupListProps = {
  radioItems: RadioItem[];
  onChange?: (value: string) => void;
  selectedValue?: string;
};
export const RadioGroupList = ({ radioItems, onChange, selectedValue }: RadioGroupListProps) => {
  return (
    <RadioGroup className="flex" defaultValue="all" onValueChange={onChange} value={selectedValue}>
      {radioItems.map(({ label, value }) => (
        <div key={value} className="flex items-center space-x-2">
          <RadioGroupItem value={value} id={value} className={cn({ ['bg-primary']: selectedValue === value })} />
          <Label htmlFor={value}>{label}</Label>
        </div>
      ))}
    </RadioGroup>
  );
};
